module.exports = __webpack_public_path__ + "img/em-tempering-technology-02.e6b18f0e.jpeg";